import * as React from "react";
import {cx} from "emotion";

import "./additional-options-modal.scss";

import {bindInput}                      from "@Common/react/bind-input";
import {cs}                             from "@Common/react/chain-services";
import {consumeContext}                 from "@Common/react/context";
import {convertState}                   from "@Common/react/convert-state";
import {Form2}                          from "@Common/react/cs-form-2/form2";
import {urlFormatValidation}            from "@Common/react/cs-form-2/validators/url-format-validation";
import {scopedState}                    from "@Common/react/scoped-state";
import {scnv}                           from "@Common/react/state-change-nested-value";
import {UseState}                       from "@Common/react/use-state";
import {Select}                         from "@Common/ui-components/heavy/common/design2/select/select";
import {SelectMailingListModal}         from "@Common/ui-components/heavy/mailing-ui/select-mailing-list-modal/select-mailing-list-modal";
import {ModalService3}                  from "@Common/ui-components/modal-service-3/modal-service-3";
import {getNestedValue, setNestedValue} from "@Common/utils/arr-path";
import {chain2}                         from "@Common/utils/fs";
import {mapValues, oMapToArr, omit}     from "@Common/utils/objects";

import {coatingLabels} from "../coating-labels";

import {PillList} from "./pill-list/pill-list";

export const AdditionalOptionsModal = (
    {
        programPrefs,
        product,
        store,
        mailing,

        mailingLists,

        defaultUrl,
        coating,

        next: rootNext,
    }
) => cs(
    ["modal", ({}, next) => ModalService3({
        title: "Additional Options",
        // initShow: true,
        width: 402,
        // top: 100,
        next,
        rootNext,
    })],
    consumeContext("apis"),
    ["fields", (_, next) => next({
        mailingClass: {
            path: ["products", product, "options", "mailClassDefault"],
        },
        defaultCoating: {
            path: ["products", product, "options", "defaultCoating"],
        },
        includeOrResident: {
            programPath: ["programPreferences", "includeOrResident"],
            userPath: ["prefData", "includeOrResident"],
        },
        defaultMailingList: {
            userPath: ["prefData", "defaultMailingLists"],
        },
        defaultUrl: {
            path: ["products", "socialMedia", "options", "defaultUrl"],
            validators: [urlFormatValidation],
        },
    })],
    ["data", ({fields}, next) => UseState({
        getInitValue: () => chain2(
            {},
            oMapToArr(fields, (v, k) => (
                (_) => setNestedValue(_, [k], getNestedValue(store.prefs, v.userPath ?? v.path))
            ))
        ),
        next,
    })],
    ["form", ({data, fields}, next) => Form2({
        data,
        fields: mapValues(fields, ({validators}) => validators),
        next,
    })],
    ({modal, data, apis, fields, form}) => (
        <div className="additional-options-modal-6ec">
            <div className="lines">
                {mailing && (
                    <div className="line single-line">
                        <div className="label">
                            Mailing Class
                        </div>
                        <div className="control">
                            {Select({
                                list: [
                                    "First Class",
                                    "Standard",
                                ],
                                isSelected: (_) => _ === (data.value?.mailingClass || getNestedValue(programPrefs, fields.mailingClass.path)),
                                onChange: (_) => scnv(data, ["mailingClass"], () => _),
                            })}
                        </div>
                    </div>
                )}
                {coating && (
                    <div className="line single-line">
                        <div className="label">
                            Coating Options
                        </div>

                        <div className="control">
                            {Select({
                                list: [
                                    "high_gloss_coating",
                                    "matte_touch_coating",
                                    "soft_touch_coating",
                                ],
                                itemToLabel: (_)=>coatingLabels[_],
                                isSelected: (_) => _ === (data.value?.defaultCoating || getNestedValue(programPrefs, fields.defaultCoating.path)),
                                onChange: (_) => scnv(data, ["defaultCoating"], () => _),
                            })}
                        </div>
                    </div>
                )}

                {mailing && (
                    <div className="line ml">
                        <div className="label">
                            Default Mailing List
                        </div>

                        <div className="control">
                            {(() => {
                                const mls = data.value?.defaultMailingList;

                                // console.log("mls", mls);

                                return <>
                                    <div className="list">
                                        {PillList({
                                            list: mls?.map(({id, name, mailingListName}) => ({
                                                label: mailingListName??name,
                                                key: id,
                                                onRemove: () => {
                                                    scnv(data, ["defaultMailingList"], (_) => mls.filter((ml) => ml.id !== id));
                                                },
                                            })),
                                            placeholder: "No mailing lists selected",
                                        })}
                                    </div>
                                    <div className="actions">
                                        <a
                                            onClick={() => scnv(data, ["defaultMailingList"], (_) => [])}
                                        >
                                            Clear All Lists
                                        </a>
                                        {cs(
                                            ["selectMailingListModal", ({}, next) => SelectMailingListModal({
                                                mailingListIds: convertState(scopedState(data, ["defaultMailingList"]), {
                                                    forward: (mls) => mls?.map((ml) => ml.id),
                                                    backward: (mlIds) => mlIds?.map((mlId) => mailingLists.value?.find((ml) => ml.id === mlId)),
                                                }),
                                                mailingLists,
                                                next,
                                            })],
                                            ({selectMailingListModal}) => (
                                                <button
                                                    onClick={() => {
                                                        selectMailingListModal.show();
                                                    }}
                                                >
                                                    + LIST
                                                </button>
                                            )
                                        )}
                                    </div>

                                </>;
                            })()}
                        </div>

                    </div>
                )}
                {mailing && (
                    <div className="line single-line">
                        <div className="label">
                            Include or Resident
                        </div>
                        <div className="control">
                            {Select({
                                list: [0,1],
                                itemToLabel: (_)=>_ ? "Yes" : "No",
                                isSelected: (_) => _ === (data.value?.includeOrResident ?? getNestedValue(programPrefs, fields.includeOrResident.programPath)),
                                onChange: (_) => {
                                    scnv(data, ["includeOrResident"], () => _);
                                },
                            })}
                        </div>
                    </div>
                )}
                {defaultUrl && (() => {
                    const field = form.field("defaultUrl");
                    return (
                        <div className="line double-line">
                            <div className="label">
                                Default URL
                            </div>
                            <div className="control">
                                <input {...{
                                    ...bindInput(field.state),
                                    ref: field.ref,
                                    className: cx(field.errCss, {hasError: field.error}),
                                    placeholder: getNestedValue(programPrefs, fields.defaultUrl.path) || "https://",
                                }}/>
                            </div>
                        </div>
                    );
                })()}


            </div>

            <div className="footer">
                <button
                    className="cancel"
                    onClick={modal.close}
                >
                    Cancel
                </button>
                {cs(
                    ["saving", (_, next) => UseState({next})],
                    ({saving}) => (
                        <button
                            className={cx("next", {disabled: !form.valid})}
                            disabled={saving.value}
                            onClick={async () => {
                                form.submit({
                                    onSubmit: async () => {
                                        saving.onChange(true);
                                        try {
                                            await store.dispatch(savePrefs(data.value, {fields, apis}));
                                            modal.close();
                                        } finally {
                                            saving.onChange(false);
                                        }
                                    },
                                });
                            }}
                        >
                            {!saving.value ? (
                                "Save"
                            ) : <>
                                <i className="fa fa-spinner fa-pulse"/>{" "}
                                Saving...
                            </>}
                        </button>
                    )
                )}
            </div>
        </div>
    ),
);

const savePrefs = (data, {fields, apis}) => ({
    action: async (oldData) => {
        const newData = chain2(
            omit(oldData, ["error"]),
            oMapToArr(fields, (v, k) => {
                if (!data.hasOwnProperty(k)) {
                    return v=>v;
                }
                return (_) => setNestedValue(_, v.userPath ?? v.path, data[k]);
            }),
        );
        await apis.listings.saveCleanUserPrefs(newData);
        return {
            change: () => newData,
        };
    },
});
